<template>
  <router-view></router-view>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

<script>

export default {
  name: 'App',
  components: {
  },
  watch:{
    //監看登入狀態
    '$store.state.auth.isLogin':function(){
      if(this.$store.state.auth.isLogin==false){
        this.$router.push({
          'name':'login'
        });
      }
    }
  },
  mounted:function(){
    document.title = '屏南區臨時短期照顧服務系統';
  }
}
</script>